export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const SET_LANDING_DATA = "SET_LANDING_DATA";
export const SET_GRAPH_DATA = "SET_GRAPH_DATA";
export const SET_DATA_FILTER = "SET_DATA_FILTER";
export const SET_VET_COUNT_FILTER = "SET_VET_COUNT_FILTER";
export const SET_TOP5_RATED_FILTER = "SET_TOP5_RATED_FILTER";
export const SET_NOTIFICATION_DATA = "SET_NOTIFICATION_DATA";
export const SET_NOTIFICATION_SEEN = "SET_NOTIFICATION_SEEN";
